import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const run = async () => {
      const params = new URLSearchParams(location.hash.slice(1));
      const sessionId = params.get("session_id");
      if (!sessionId) {
        navigate("/beheer", { replace: true });
        return;
      }
      try {
        const { data } = await axios.post(
          `${API}/auth/google-session`,
          { session_id: sessionId },
          { withCredentials: true }
        );
        navigate("/beheer", { replace: true, state: { user: data } });
      } catch (e) {
        const detail = e.response?.data?.detail;
        navigate("/beheer", {
          replace: true,
          state: { authError: typeof detail === "string" ? detail : "Inloggen met Google is mislukt." },
        });
      }
    };
    run();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="flex min-h-screen items-center justify-center bg-background" data-testid="auth-callback-loading">
      <Loader2 size={32} className="animate-spin text-primary" />
    </div>
  );
}
